import * as Highcharts from 'highcharts';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import {Card, CardContent} from '@mui/material';
import {COLORS} from "../../../utils/constants";
import isNumeric from "../../../utils/isNumeric";
import makeAverage from "../../../utils/makeAverage";

interface IAutonomyLevelData {
    submissions: any[];
    uoa: string | number
}

const KEYS = [
    'attitudine_propositiva',
    'energie_a_disposizionemotricita',
    'desiderio_di_socializzare',
    'serenita_e_felicita_globale',
]

const GlobalWellLevel = ({submissions, uoa}: IAutonomyLevelData) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        const allSubmissions: any = {}
        const currentSubmissions: any = {}

        submissions.forEach((submission: any) => {
            KEYS.forEach((key: string) => {
                const question = `question14_${key}`;

                if (submission.hasOwnProperty(question) && isNumeric(submission[question])) {
                    const answer = parseInt(submission[question])

                    if (!allSubmissions.hasOwnProperty(key)) {
                        allSubmissions[key] = []
                    }

                    allSubmissions[key].push(answer)

                    if (submission.uoa_parent_id === uoa) {
                        if (!currentSubmissions.hasOwnProperty(key)) {
                            currentSubmissions[key] = []
                        }

                        currentSubmissions[key].push(answer)
                    }
                }
            })
        })

        const dashboardOptions: Highcharts.Options = {
            chart: {
                polar: true,
                style: {
                    fontFamily: 'Rubik, sans-serif'
                },
                backgroundColor: '#fafafa',
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: [
                    'Attitudine propositiva',
                    'Energie a disposizione/motricità',
                    'Desiderio di socializzare',
                    'Serenità e felicità globale',
                ]
            },
            series: [
                {
                    type: 'line',
                    name: 'Il mio progetto',
                    data: KEYS.map((key) => currentSubmissions.hasOwnProperty(key) ? makeAverage(currentSubmissions[key]) : 0),
                    color: COLORS.blue,
                },
                {
                    type: 'line',
                    name: 'Media dei progetti',
                    data: KEYS.map((key) => allSubmissions.hasOwnProperty(key) ? makeAverage(allSubmissions[key]) : 0),
                    color: COLORS.red,
                },
            ]
        };

        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card>
            <CardContent>
                {
                    options && (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                            ref={chartComponentRef}
                        />
                    )
                }
            </CardContent>
        </Card>

    );
};

export default GlobalWellLevel;
